export default {
  mainColor: '#167caa',
  documentBackgroundColor: '#abe2ff',
  frameBackgroundColor: '#fff',
  frameOverlayColor: 'rgba(255, 255, 255, 0.5)',

  white: '#fff',
  black: '#000',
  offWhite: '#F5F5F5',
  offBlack: '#0a0a0a',
  gray: '#555',
  graySemiLight: '#777',
  grayLight: '#999',
  grayABitLighter: '#dadada',
  grayLighter: '#EEE',

  blue: '#049CDB',
  blueLight: '#5bcaff',
  blueDark: '#105B7D',
  blueSemiDark: '#167caa',
  blueVeryDark: '#343e4b',
  green: '#69bf69',
  red: '#B70D0D',
  orange: '#FF9800',
  orangeLight: '#F9B963',
  yellow: '#ffc500',
  yellowPale: '#f1cb7b',
  brightYellowPale: '#ffee73',
  brightYellowPaleFaded: '#feed73b3',
  orangeVeryPale: '#ffe2bf',
  brighterYellowPale: '#fff7be',
  hotMagentaPink: '#ff005a',
  lilac: '#bba3cc',
  violet: '#7975b4',
  indigo: '#3c3c69',

  textColor: '#333333',

  // Adaptive battle colors
  adaptiveBattlePointsColor: '#06A59C',
  adaptiveBattleWinsColor: '#0090cf',
}

export const chartColors = {
  blue: '#38abe7',
  red: '#e73b38',
  green: '#38e73b',
  yellow: '#e7cd38',
  orange: '#e79238',
}
